import { LocalesProvider, NotificationProvider } from '@cez-dje/providers';
import { Tooltip } from 'radix-ui';
import type { FC, ReactNode } from 'react';
import { type AppConfig, ConfigProvider } from '@/configuration/appConfiguration';

interface ProvidersProps {
  config: AppConfig;
  children: ReactNode;
}

export const Providers: FC<ProvidersProps> = ({ config, children }) => {
  return (
    <ConfigProvider config={config}>
      <LocalesProvider language='cs'>
        <Tooltip.Provider delayDuration={300}>
          <NotificationProvider>{children}</NotificationProvider>
        </Tooltip.Provider>
      </LocalesProvider>
    </ConfigProvider>
  );
};
